export const CHECKOUT_URL =
  'https://industrial-maintenance-diagnostic-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const PRODUCT = 'INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/5uB4Nx6hba5Q7yyCokkikR/Diseno_sin_titulo-2.png'

export interface PreviewImage {
  src: string
  alt: string
}

export const previewImages: PreviewImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/wQBXWrufR1fX2g4NBHkN8g/Captura-de-pantalla-2026-09-14-a-la_s_-5.15.28_p.-m..webp',
    alt: 'Rapid Pneumatic Inspection Route — 10-step visual inspection map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rqcuuM5zk7LQLchh6zUUcj/Captura-de-pantalla-2026-09-14-a-la_s_-5.16.53_p.-m..webp',
    alt: 'Pneumatic System Component Map — supply, control and actuation',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xdBM85Uuy4MXvB1n9ZiK2P/Captura-de-pantalla-2026-09-14-a-la_s_-5.15.46_p.-m..webp',
    alt: 'Control Fault or Fluid-Power Fault? — fault isolation decision map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9qRwtJBbhnBUznmCTovKTC/Captura-de-pantalla-2026-09-14-a-la_s_-5.16.07_p.-m..webp',
    alt: 'Pneumatic Air Leak Detection Map — 10 leak points and evidence to check',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kjtAgytpgZM46NNndQnnwj/Captura-de-pantalla-2026-09-14-a-la_s_-5.16.28_p.-m..webp',
    alt: 'Hydraulic Fluid Condition Visual Guide — 5 fluid condition references',
  },
]

export interface Module {
  num: number
  title: string
  body: string[]
  kicker: string
}

export const modules: Module[] = [
  {
    num: 1,
    title: 'INDUSTRIAL TROUBLESHOOTING & FAULT ISOLATION SYSTEM™',
    body: [
      'Follow structured diagnostic paths from the first visible symptom.',
      'Use inspection routes, symptom maps and fault-isolation sequences to narrow possible causes.',
    ],
    kicker: 'Observe. Isolate. Narrow.',
  },
  {
    num: 2,
    title: 'MOTORS, DRIVES & POWER TRANSMISSION DIAGNOSTICS™',
    body: [
      'Troubleshoot motors, couplings, belts, chains, gearboxes and drive components.',
      'Identify symptoms related to overheating, vibration, slipping, wear and abnormal operation.',
    ],
    kicker: 'Inspect. Compare. Diagnose.',
  },
  {
    num: 3,
    title: 'BEARINGS, LUBRICATION, VIBRATION & MECHANICAL WEAR™',
    body: [
      'Identify signs of bearing problems, lubrication issues, vibration, misalignment and mechanical wear.',
      'Use visual references to know where to inspect and what evidence to look for.',
    ],
    kicker: 'Observe. Inspect. Confirm.',
  },
  {
    num: 4,
    title: 'HYDRAULIC & PNEUMATIC SYSTEM DIAGNOSTICS™',
    body: [
      'Troubleshoot pressure loss, leaks, slow movement and inconsistent actuator performance.',
      'Work through pumps, valves, cylinders, hoses and pneumatic components.',
    ],
    kicker: 'Pressure. Flow. Diagnose.',
  },
  {
    num: 5,
    title: 'INDUSTRIAL ELECTRICAL, SENSORS & CONTROL FAULTS™',
    body: [
      'Identify electrical, sensor and control-related machine problems.',
      'Inspect contactors, relays, overloads, switches, sensors and control components through structured fault paths.',
    ],
    kicker: 'Check. Isolate. Verify.',
  },
  {
    num: 6,
    title: 'INDUSTRIAL EQUIPMENT FAILURE LIBRARY™',
    body: [
      'Start directly from the machine symptom.',
      'Access rapid diagnostic references for no-starts, shutdowns, overheating, vibration, noise, pressure loss, overloads and other common failures.',
    ],
    kicker: 'Find. Follow. Diagnose.',
  },
]

export interface Bonus {
  num: number
  title: string
  count: string
  body: string
  kicker: string
}

export const bonuses: Bonus[] = [
  {
    num: 1,
    title: 'INDUSTRIAL MACHINE INSPECTION CHECKLIST PACK™',
    count: '10 Ready-to-Use Professional Checklists',
    body: 'Inspect motors, bearings, lubrication, hydraulics, pneumatics, sensors and machine condition with structured field checklists.',
    kicker: 'Inspect. Record. Follow Up.',
  },
  {
    num: 2,
    title: 'RAPID FAULT ISOLATION DECISION TREE PACK™',
    count: '12 Professional Troubleshooting Decision Trees',
    body: 'Follow clear diagnostic paths for common symptoms including no-starts, vibration, overheating, overloads and intermittent faults.',
    kicker: 'Symptom. Decision. Isolation.',
  },
  {
    num: 3,
    title: 'MACHINE FAILURE REPORT & TROUBLESHOOTING LOGBOOK™',
    count: '15 Ready-to-Use Professional Forms',
    body: 'Document failures, diagnostic steps, observations, corrective work and recurring machine problems.',
    kicker: 'Diagnose. Document. Reference.',
  },
  {
    num: 4,
    title: 'PREVENTIVE CONDITION WARNING SIGNS FIELD GUIDE™',
    count: '20 Early Warning Signs to Watch',
    body: 'Recognize signs involving noise, vibration, heat, lubrication, bearings, hydraulics, sensors and mechanical wear.',
    kicker: 'Notice. Inspect. Document.',
  },
  {
    num: 5,
    title: 'MAINTENANCE SHIFT HANDOVER & PRIORITY CONTROL KIT™',
    count: '8 Ready-to-Use Maintenance Tools',
    body: 'Track open faults, unresolved diagnostics, recurring failures, follow-ups and shift handovers.',
    kicker: 'Track. Communicate. Continue.',
  },
]

export const differentiators = [
  {
    icon: '🔧',
    title: 'Visual diagnostic resources',
    body: 'Find the right troubleshooting reference when you need it.',
  },
  {
    icon: '📋',
    title: 'Structured fault isolation',
    body: 'Move from symptom to possible cause with a clearer process.',
  },
  {
    icon: '⚙️',
    title: '6 diagnostic areas',
    body: 'Motors, mechanical systems, hydraulics, pneumatics, sensors and controls.',
  },
  {
    icon: '🔄',
    title: 'Ready to use again and again',
    body: 'Return to the tools whenever a new machine problem appears.',
  },
]

export const offerIncludes = [
  '6 professional modules',
  '5 professional bonuses',
  'Visual diagnostic maps',
  'Fault-isolation tools',
  'Inspection checklists',
  'Troubleshooting decision trees',
  'Professional field references',
]

export interface Testimonial {
  name: string
  role: string
  location: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Darren Whitfield, 47',
    role: 'Industrial Maintenance Technician — food packaging plant',
    location: 'Sheffield, United Kingdom',
    quote:
      'After 20 years on the floor I still lost time chasing causes in the wrong order. Now I open the symptom map, work the checks in sequence and stop second-guessing myself. Last week a filler kept tripping on overload — the motor and drive path took me straight to a loose coupling instead of another blind teardown.',
  },
  {
    name: 'Marcus Delgado, 34',
    role: 'Electromechanical Technician — automotive stamping line',
    location: 'Toledo, Ohio, United States',
    quote:
      'The fault isolation decision trees are what sold me. When a press shows intermittent behaviour on night shift with nobody to ask, I follow the path instead of guessing. I have used the pneumatic leak map three times already and documented every finding in the logbook forms.',
  },
  {
    name: 'Ian Fraser, 52',
    role: 'Maintenance Mechanic — pulp and paper mill',
    location: 'Hamilton, Ontario, Canada',
    quote:
      'I print the inspection checklists and keep them in the toolbox. Bearings, lubrication and vibration used to be where I wasted the most time — now I know exactly what evidence to look for before I pull anything apart. The hydraulic fluid condition guide alone has changed how I inspect.',
  },
  {
    name: 'Rachel Cormack, 39',
    role: 'Plant Maintenance Supervisor — bottling facility',
    location: 'Brisbane, Australia',
    quote:
      'I handed it to my whole crew. The shift handover kit means open faults and unresolved diagnostics actually get passed on, instead of restarting from scratch every morning. Our repeat callouts on the same machines dropped noticeably in the first month.',
  },
  {
    name: 'Tomasz Nowak, 29',
    role: 'Junior Maintenance Technician — plastics injection moulding',
    location: 'Birmingham, United Kingdom',
    quote:
      'As the newest tech I was terrified of being alone with a down machine. The failure library lets me start from the symptom — no start, overheating, pressure loss — and follow a proper process. My supervisor noticed I stopped calling him for every fault.',
  },
]

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Who is this system for?',
    a: 'Industrial maintenance technicians, maintenance mechanics, electromechanical technicians and plant maintenance personnel.',
  },
  {
    q: 'Is this a physical product?',
    a: 'No. INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™ is a 100% digital resource.',
  },
  {
    q: 'Is this a training course or certification?',
    a: 'No. It is a practical professional troubleshooting reference system.',
  },
  {
    q: 'Is it another theory-heavy ebook?',
    a: 'No. It focuses on visual diagnostic maps, checklists, decision trees, inspection resources and field references.',
  },
  {
    q: 'What areas are included?',
    a: 'Fault isolation, motors and drives, mechanical components, hydraulics, pneumatics, sensors and controls.',
  },
  {
    q: 'Does this replace professional procedures or manufacturer instructions?',
    a: 'No. Always follow manufacturer documentation, professional safety procedures and applicable workplace requirements.',
  },
  {
    q: 'How will I receive it?',
    a: "You'll receive immediate digital access after purchase.",
  },
  {
    q: 'Do I need experience to use it?',
    a: 'It is built for working maintenance personnel. Newer technicians use it to follow a structured path; experienced technicians use it to move faster from symptom to possible cause.',
  },
  {
    q: 'Can I print the checklists and decision trees?',
    a: 'Yes. The checklists, decision trees, logbook forms and field references are made to be printed and used on the floor.',
  },
  {
    q: 'What if it is not right for me?',
    a: 'Contact us within 7 days of purchase for a full refund according to the refund terms.',
  },
]

export const purchaseEvents = [
  { name: 'James T.', city: 'Manchester, United Kingdom' },
  { name: 'Robert M.', city: 'Houston, Texas, United States' },
  { name: 'Liam K.', city: 'Calgary, Alberta, Canada' },
  { name: 'Ethan B.', city: 'Perth, Australia' },
  { name: 'David S.', city: 'Glasgow, United Kingdom' },
  { name: 'Michael R.', city: 'Detroit, Michigan, United States' },
  { name: 'Connor W.', city: 'Melbourne, Australia' },
  { name: 'Aaron P.', city: 'Mississauga, Ontario, Canada' },
  { name: 'Shane D.', city: 'Leeds, United Kingdom' },
  { name: 'Kevin L.', city: 'Phoenix, Arizona, United States' },
]
